import React, { useMemo, useState } from 'react';
import { CardBoxProvider } from './card-box.provider';
import { ICardBox, ICardBoxProps } from './card-box.types';
import { CardBoxHeading } from './card-box-heading';
import { CardBoxContent } from './card-box-content';
import { StyledWrapper } from './card-box.styles';

export const CardBox: ICardBox<ICardBoxProps> = ({ className, hideByDefault, allowCollapse, children }) => {
    const [opened, setOpened] = useState(!hideByDefault);

    const contextValue = useMemo(() => ({
        opened,
        setOpened,
        allowCollapse
    }), [allowCollapse, opened]);

    return (
        <CardBoxProvider.Provider value={contextValue}>
            <StyledWrapper className={className}>
                {children}
            </StyledWrapper>
        </CardBoxProvider.Provider>
    );
};

CardBox.Heading = CardBoxHeading;
CardBox.Content = CardBoxContent;
